var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foroContainer"},_vm._l((_vm.foros),function(item){return _c('div',{key:item.Id,staticClass:"card"},[_c('ForoCard',{attrs:{"post":item,"isHome":true},on:{"openPost":_vm.openPost}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }